import * as React from "react"
import { Divider, Grid } from "@mui/material"

import AdminBrandsNameTextField from "./BrandTextField"
import AdminBrandsColorPicker from "./Color"
import AdminBrandsCompanyAutocomplete from "./Company"
import AdminBrandsCustomerAutocomplete from "./Customer"
import AdminBrandsFormSwitch from "./Switch"
import AdminBrandsDisplayNameTextField from "./DisplayNameTextField"
import AdminBrandsKeywordTextField from "./KeywordTextField"
import AdminBrandsExcludedWordTextField from "./ExcludedWordTextField"
import AdminBrandsKeywordTester from "./KeywordTester"
import AdminBrandsCustomerAvailability from "./CustomerAvailability"

import { USER_ENV } from "@constants"
import { useUserApp } from "@hooks"


export default function AdminBrandsCreateDrawerContent() {
    // Puig-only: retail's brands have no availability flags in this dashboard.
    const { userEnv } = useUserApp()
    const isPuig = userEnv === USER_ENV.PUIG

    return <Grid container spacing={3}>
        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsNameTextField />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsDisplayNameTextField />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsCompanyAutocomplete />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsCustomerAutocomplete />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsKeywordTextField />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsExcludedWordTextField />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsColorPicker />
            </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsFormSwitch label="Validated" field="validated" />
            </Grid>

            <Grid item xs={6}>
                <AdminBrandsFormSwitch label="Whole Word" field="wholeWord" />
            </Grid>
        </Grid>

        {isPuig && <Grid item xs={12}>
            <AdminBrandsCustomerAvailability />
        </Grid>}

        <Grid item xs={12}>
            <Divider />
        </Grid>

        <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
                <AdminBrandsKeywordTester />
            </Grid>
        </Grid>
    </Grid>
}
